import chrome from './chrome.png';
import opera from './opera.png';
import safari from './safari.png';
import edge from './edge.png';
import firefox from './firefox.png';

export default [
  {
    name: 'Chrome',
    link: 'https://www.google.com/chrome/browser/desktop/index.html',
    image: chrome,
  },
  {
    name: 'FireFox',
    link: 'https://www.mozilla.org/en-US/firefox/new/',
    image: firefox,
  },
  {
    name: 'Microsoft Edge',
    link: 'https://www.microsoft.com/en-pk/download/details.aspx?id=48126',
    image: edge,
  },
  {
    name: 'Safari',
    link: 'https://www.apple.com/safari/',
    image: safari,
  },
  {
    name: 'Opera',
    link: 'http://www.opera.com/download',
    image: opera,
  },
];
